import { Dropdown, Image } from "antd";
import { useState } from "react";
import { useGetAlertsQuery } from "../../../../lib/api/endpoints/settings/settingsEndpoints";
import G_Div from "../../Containers/G_Div";
import NotificationOverlay from "../NotificationOverlay";

const NotificationHandler = () => {
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const { data: alerts } = useGetAlertsQuery({ page: 0, size: 10 });
  const notify = !!alerts?.payload?.content?.length;

  return (
    <Dropdown
      overlay={
        <NotificationOverlay setIsNotificationOpen={setIsNotificationOpen} />
      }
      placement="bottomRight"
      trigger={["click"]}
      open={isNotificationOpen}
      onOpenChange={() => setIsNotificationOpen(false)}
    >
      <G_Div
        className="relative cursor-pointer"
        onClick={() => setIsNotificationOpen(true)}
      >
        {notify && (
          <G_Div className="w-[12px] h-[12px] absolute top-[16px] right-[-2px] rounded-full border-2 border-ox_2_darker_blue bg-ox-red flex items-center justify-center z-10" />
        )}
        <Image
          width={notify ? 18 : 14}
          src="/icons/white-bell-icon.svg"
          preview={false}
          alt=""
          className="cursor-pointer mt-2"
        />
      </G_Div>
    </Dropdown>
  );
};

export default NotificationHandler;
